import { render, staticRenderFns } from "./SovecoNavBar.vue?vue&type=template&id=969b789a"
import script from "./SovecoNavBar.vue?vue&type=script&lang=js"
export * from "./SovecoNavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports